.warning-container {
	font-family: Helvetica, Arial, sans-serif;
	/* position: relative; */
	display: flex;
	justify-content: center;
	align-items: center;
}
.warning-icon {
	font-size: 24px;
}
.warning-icon:hover {
	cursor: pointer;
}

.warning-button {
	border:solid 1px #f3bb45;
	width: 35px;
	border-radius: 100%;
	padding: 5px 0;
	background-color: #fff;
}
.warning-info {
	position: absolute;
	left: 5vw;
	z-index: 999;
	
	box-sizing: border-box;
	padding: 0 12px;
	
	font-size: 16px;
	line-height: 24px;
	
	background: white;
	border: 1px solid #f3bb45;
	box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
	display: flex;
    flex-direction: column;
}
.error-card{
    text-align:left;
    border-bottom: 1px solid rgba(0, 0, 0, .2);
}

.title{
    display: block;
	font-size: 18px;
	font-weight: 400;
	margin: 5px 0 0px 0;
}
.subtitle{
    display: block;
	font-size: 16px;
	font-weight: 400;
	margin: 0px 0 5px 0;
}
.error-card{
	inline-size: 450px;
	overflow-wrap: break-word;
	white-space: pre-wrap;      /* CSS3 */   
	white-space: -moz-pre-wrap; /* Firefox */    
	white-space: -pre-wrap;     /* Opera <7 */   
	white-space: -o-pre-wrap;   /* Opera 7 */    
	word-wrap: break-word; 
}

.error-card p {
	font-size: 14px;
	font-weight: 300;
	margin: 5px 0 5px 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/BeneUpload/upload.css
// module id = 1004
// module chunks = 0